import {
  PAYMENT_PAGE_LOAD_REQUESTED,
  PAYMENT_PAGE_LOAD_REQUESTED_AFTER_LOGIN,
  CAMPAIGN_UPDATE_STATE,
  PAYMENT_PAGE_LOAD_SUCCEEDED,
  PAYMENT_PAGE_LOAD_FAILED,
} from '../actions';

const initialState = {
  error: false,
  fetching: false,
};

export default (state = initialState, { type }) => {
  switch (type) {
    case PAYMENT_PAGE_LOAD_REQUESTED:
    case PAYMENT_PAGE_LOAD_REQUESTED_AFTER_LOGIN:
    case CAMPAIGN_UPDATE_STATE:
      return { ...state, fetching: true };
    case PAYMENT_PAGE_LOAD_SUCCEEDED:
      return { ...state, error: false, fetching: false };
    case PAYMENT_PAGE_LOAD_FAILED:
      return { ...state, error: true, fetching: false };
    default:
      return state;
  }
};
